<div class="modal-header">
    <h5 class="modal-title mb-0 fs-5">Promotion Eligibility</h5>
</div>
<div class="modal-body">
    <table class="table table-bordered table-sm table-striped" style="font-size: 10px;">
        <thead>
            <tr>
                <th>Promotion</th>
                <th>Eligible</th>
                <th>Message</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let condition of conditions">
                <td>{{condition.title}}</td>
                <td class="text-center text-light" [ngClass]="condition.can_claim ? 'bg-success' : 'bg-danger'">{{condition.can_claim ? 'Yes' : 'No'}}</td>
                <td>{{condition.message ? condition.message : '-'}}</td>
            </tr>
        </tbody>
    </table>
    <button class="btn btn-primary w-100" (click)="close()">Close</button>
</div>
